import { useTranslation } from "react-i18next";

export default function SignedNotification() {
  const { t } = useTranslation();
  return (
    <div
      className={`absolute top-2/4 mt-2 left-1/2 -translate-x-1/2 px-6 py-6  rounded-lg shadow-lg
          text-3xl font-medium transition-opacity duration-[1500ms]  z-50 bg-white/95 text-purple-500
          opacity-90`}
    >
      {t("status.signedNotification")}
    </div>
  );
}
